import config from 'cio/config/environment';
import { TrackingScript, TrackingContext } from 'cio/utils/tracking-scripts/types';

export const GoogleTagManagerHeadTag: TrackingScript = {
  tag: 'script',
  id: 'google-tag-manager-head',
  content: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${config['google-tag-manager'].id}')`,

  inject(element: HTMLElement, ctx: TrackingContext) {
    if ((config.isProduction || config.isProdStaging || config.isStandalone) && !ctx.authenticated) {
      document.head.appendChild(element);
    }
  },
};

export const GoogleTagManagerBodyTag: TrackingScript = {
  tag: 'noscript',
  id: 'google-tag-manager-body',
  content: `<iframe src="https://www.googletagmanager.com/ns.html?id=${config['google-tag-manager'].id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,

  inject(element: HTMLElement, ctx: TrackingContext) {
    // Insert as high up in the body tag as possible
    if ((config.isProduction || config.isProdStaging || config.isStandalone) && !ctx.authenticated) {
      document.body.insertBefore(element, document.body.firstChild);
    }
  },
};
